import { Info, Warning } from 'phosphor-react';
import React, { useEffect, useState } from 'react';

const Notification = ({ type, text, icon, duration, className, children }) => {
  if (!icon) {
    switch (type) {
      case 'warning':
      case 'error':
        icon = <Warning size={24} />;
        break;

      case 'info':
        icon = <Info size={24} />;
        break;

      case 'success':
        icon = <span style={{ fontSize: '20px' }}>👍</span>;
        break;

      default:
        break;
    }
  }

  return (
    <div
      className={`notification ${type ? 'notification--' + type : ''} ${
        className ?? ''
      }`}
    >
      <div className="notification__content-wrapper">
        {icon && <div className="notification__icon-wrapper">{icon}</div>}
        {text}
        {children}
      </div>
      {duration > 0 && (
        <div className="notification__timer">
          <div
            className="notification__timer-filler"
            style={{
              animationName: 'timer',
              animationDuration: `${duration}ms`,
              animationTimingFunction: 'linear',
              animationFillMode: 'forwards',
              animationPlayState: 'running',
            }}
          ></div>
        </div>
      )}
    </div>
  );
};

export default Notification;
